/* eslint-disable react/jsx-key */
import {
  Button,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  FormHelperText
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { quizSubmit } from '../../../../../helper/api.helper';
import Loader from '../../../../../components/loader/Loader';
import { getOrgCode } from '../../../../../helper/utils.helper';

const QuizPage = ({ section, setVisitedPages, courseActivityId }) => {
  const [isLoading, setLoading] = useState(false);
  const [quiz, setQuiz] = useState([]);
  const [score, setScore] = useState(null);
  const [pass, setPass] = useState(false);
  const [answers, setAnswers] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [attemptedSubmit, setAttemptedSubmit] = useState(false);
  const [correctAnswers, setCorrectAnswers] = useState({});
  const [allowRetake, setAllowRetake] = useState(false);

  useEffect(() => {
    setQuiz(section.quiz);
  }, []);

  const handleOptionChange = (questionIndex, selectedOption) => {
    const queNo = questionIndex + 1;
    setAnswers((prevAnswers) => ({
      ...prevAnswers,
      [queNo]: selectedOption
    }));
  };

  const handleQuizSubmit = async () => {
    setLoading(true);
    const orgCode = getOrgCode();
    const allAnswered = await quiz.every((_, index) => answers[index + 1]);

    if (!allAnswered) {
      setLoading(false);
      setAttemptedSubmit(true);
      return;
    }

    await quizSubmit(orgCode, courseActivityId, { responses: answers, sectionId: section.id })
      .then((res) => res.json())
      .then((res) => {
        if (res.status === 'success') {
          if (res.data?.status) {
            setPass(true);
            setCorrectAnswers(
              res.data.answers.reduce((acc, answer) => {
                acc[answer.question] = answer.ans;
                return acc;
              }, {})
            );
            setVisitedPages((prevState) => ({
              ...prevState,
              [section.id]: true
            }));
            toast.success('You have successfully completed the quiz.');
          } else {
            // setAnswers({});
            toast('Unfortunately, you did not pass this attempt, but you may try again.');
          }
          setScore(res.data.score);
          setAllowRetake(res.data.allowRetake);
          setAttemptedSubmit(false);
          setLoading(false);
          setIsSubmitted(true);
        } else {
          setLoading(false);
          toast.error(res.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err.message);
      });
  };

  useEffect(() => {
    if (section?.responses) {
      setAnswers(section.responses);
    }
    if (section?.score) {
      setScore(section.score);
    }
    if (section?.allow_retake) {
      setAllowRetake(section.allow_retake);
    }
    if (section?.status) {
      setPass(true);
      if (section?.answers) {
        setCorrectAnswers(
          section.answers.reduce((acc, answer) => {
            acc[answer.question] = answer.ans;
            return acc;
          }, {})
        );
      }
    }
  }, [section]);

  return (
    <div className="quiz-wrapper">
      {isLoading ? <Loader /> : null}
      <h4>{section.name}</h4>
      <div className="margin-top--md">
        {section?.body?.map((section, i) =>
          section.type === 'points' ? (
            <ul key={i}>
              {section.text.map((text) => (
                <li className="margin-top--sm" key={text}>
                  {text}
                </li>
              ))}
            </ul>
          ) : (
            section.text.map((text) => (
              <p className="margin-top--sm" key={text}>
                {text}
              </p>
            ))
          )
        )}
      </div>
      {quiz.map((question, index) => (
        <div key={index}>
          <h4 style={{ fontWeight: 'normal' }}>{`${index + 1}. ${question.question}`}</h4>
          <FormControl
            fullWidth
            component="fieldset"
            error={attemptedSubmit && !answers[index + 1]}>
            <RadioGroup
              aria-label={`question-${index}`}
              name={`question-${index}`}
              value={answers[index + 1] || ''}
              onChange={(e) => handleOptionChange(index, e.target.value)}>
              {question.options.map((option, optionIndex) => {
                const isCorrect = correctAnswers[question.question] === option;
                const isSelected = answers[index + 1] === option;
                return (
                  <FormControlLabel
                    key={optionIndex}
                    value={option}
                    control={<Radio />}
                    label={option}
                    sx={{
                      border: isCorrect ? '1px solid green' : 'none',
                      backgroundColor: isCorrect
                        ? '#f2fff2'
                        : // : isSubmitted && isSelected && !isCorrect
                          // ? "lightcoral"
                          'transparent',
                      borderRadius: '5px',
                      margin: '0px'
                      // padding: "0px 10px 0px 0px",
                    }}
                  />
                );
              })}
            </RadioGroup>
            {attemptedSubmit && !answers[index + 1] && (
              <FormHelperText>Please select an option for this question.</FormHelperText>
            )}
          </FormControl>
        </div>
      ))}

      <div>
        {attemptedSubmit && (
          <p style={{ color: '#d32f2f', margin: '22px 0px 0px 10px' }}>
            Please complete all the questions.
          </p>
        )}
        {pass && (section?.score !== undefined || score !== null) ? (
          <div className="margin-top--md">
            <b className="score">
              Score -{' '}
              {score !== null ? score : section?.score !== undefined ? section?.score : null}
            </b>
          </div>
        ) : !pass && allowRetake && (section?.score !== undefined || score !== null) ? (
          <>
            <div className="flex-container">
              <p className="previous-score margin-top--md">
                Previous Score -{' '}
                {score !== null ? score : section?.score !== undefined ? section?.score : null}
              </p>
              <Button
                sx={{
                  maxHeight: '30px',
                  marginTop: '20px',
                  marginLeft: '20px',
                  textTransform: 'none'
                }}
                variant="contained"
                onClick={handleQuizSubmit}>
                Resubmit
              </Button>
            </div>
            <p className="margin-top--sm">
              Your score is below the required threshold - please re-attempt the quiz to proceed.
            </p>
          </>
        ) : !pass && (section?.score !== undefined || score !== null) ? (
          <div className="margin-top--md">
            <b className="previous-score">
              Score -{' '}
              {score !== null ? score : section?.score !== undefined ? section?.score : null}
            </b>
          </div>
        ) : !pass && section?.score === undefined && score === null ? (
          <Button
            sx={{ maxHeight: '30px', marginTop: '20px', textTransform: 'none' }}
            variant="contained"
            onClick={handleQuizSubmit}>
            Submit
          </Button>
        ) : null}
      </div>
      <style jsx>{`
        .quiz-wrapper {
          max-height: 90vh;
          overflow: scroll;
          padding: 0px 40px 20px 40px;
        }
        .score {
          padding: 3px 10px 5px 10px;
          border: 1px solid #0884ff;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
          border-radius: 3px;
        }
        .previous-score {
          padding: 3px 10px 5px 10px;
          border: 1px solid grey;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
          border-radius: 3px;
        }
        @media only screen and (max-width: 600px) {
          .quiz-wrapper {
            padding: 0px 20px 20px 20px;
          }
        }
      `}</style>
    </div>
  );
};

export default QuizPage;
